if (typeof VideoBackgroundElement !== 'function') {
	class VideoBackgroundElement extends HTMLElement {
		constructor() {
			super();
			this._eventSuccess = new Event('success');
			this._eventFail = new Event('fail');
			const video = this.querySelector('video');
			video.addEventListener('error', (e) => {
				this.switchFallback();
			});
			video.addEventListener('playing', (e) => {
				if (!this.classList.contains('loaded')) {
					this.classList.add('loaded');
					this.dispatchEvent(this._eventSuccess);
				}
			});
			video.addEventListener('stalled', (e) => {
				if (!this.classList.contains('loaded')) {
					this.switchFallback();
				}
			});

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);
				video.querySelectorAll('source').forEach((elm) => {
					elm.src = elm.dataset.src;
				});
				video.load();
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: `0px 0px 400px 0px`,
			}).observe(this);

			const muteButton = this.querySelector('.mute-button');
			const parent = this.parentElement;
			muteButton.addEventListener('click', () => {
				video.muted = !video.muted;
				// parent.classList.toggle('full-screen-video');
				video.muted
					? (muteButton.innerHTML =
							'<span class="icon"><svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_421_1115)"><circle cx="37" cy="33" r="21" fill="white"/></g><path d="M42.998 30.75V35.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.998 29.25V36.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.5 24.75L44.5 41.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M35.5142 26.9057L39.2501 24V31.0152" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M39.25 35.475V42L32.5 36.75H28C27.8011 36.75 27.6103 36.671 27.4697 36.5303C27.329 36.3897 27.25 36.1989 27.25 36V30C27.25 29.8011 27.329 29.6103 27.4697 29.4697C27.6103 29.329 27.8011 29.25 28 29.25H33.5909" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><defs><filter id="filter0_d_421_1115" x="0" y="0" width="74" height="74" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_421_1115"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_421_1115" result="shape"/></filter></defs></svg></span>')
					: (muteButton.innerHTML =
							'<span class="icon"><svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)"><g filter="url(#filter0_d_421_1107)"><circle cx="37" cy="33" r="21" fill="white"/></g><path d="M32.5 36.75H28C27.8011 36.75 27.6103 36.671 27.4697 36.5303C27.329 36.3897 27.25 36.1989 27.25 36V30C27.25 29.8011 27.329 29.6103 27.4697 29.4697C27.6103 29.329 27.8011 29.25 28 29.25H32.5L39.25 24V42L32.5 36.75Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M42.9971 30.75V35.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.9971 29.25V36.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><defs><filter id="filter0_d_421_1107" x="0" y="0" width="74" height="74" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_421_1107"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_421_1107" result="shape"/></filter></defs></svg></span>');
			});
		}

		switchFallback() {
			const fallback = this.parentElement.querySelector(
				`[data-video-background-fallback][data-id="${this.dataset.id}"]`
			);
			if (fallback) {
				fallback.append(
					fallback.querySelector('template').content.cloneNode(true)
				);
				fallback
					.querySelector('img')
					.setAttribute(
						'srcset',
						fallback.querySelector('img').getAttribute('srcset')
					);
			}
			this.dispatchEvent(this._eventFail);
		}
	}

	if (typeof customElements.get('video-background-element') == 'undefined') {
		customElements.define('video-background-element', VideoBackgroundElement);
	}
}

document.addEventListener('shopify:section:load', (e) => {
	if (e.target.classList.contains('mount-video-background')) {
		setTimeout(() => {
			e.target.querySelectorAll('video-background-element').forEach((elm) => {
				elm.querySelectorAll('source').forEach((source) => {
					source.src = source.dataset.src;
				});
				elm.querySelector('video').load();
			});
		}, 500);
	}
});
